import request from '@/utils/request';

// post /api/v1/admin/game_config/game_item/change_status 变更游戏状态
export function changeStatus(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/change_status',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/create 创建游戏
export function createGameItem(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/create',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/delete 删除游戏
export function deleteGameItem(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/delete',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/get_by_title 根据标题查询游戏
export function getGameItemByTitle(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/get_by_title',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/get_excel_template 获取游戏Excel模板
export function getGameExcelTemplate(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/get_excel_template',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/list 查询游戏列表
export function listGameItems(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/list',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/update 更新游戏
export function updateGameItem(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/update',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/upload_excel 导入游戏Excel
export function uploadGameExcel(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/upload_excel',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/update_tags 批量更新游戏标签
export function updateGameItemTags(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/update_tags',
    method: 'post',
    mock: false,
    data
  })
}

// post /api/v1/admin/game_config/game_item/remove_tags 批量移除游戏标签
export function removeGameItemTags(data) {
  return request({
    url: '/api/v1/admin/game_config/game_item/remove_tags',
    method: 'post',
    mock: false,
    data
  })
}
